<template>
  <div id="kontakt">
    <div class="row section-whitespace special-left-grid">
      <div class="small-12 medium-5 columns">
        <img class="fullwidth" src="/static/zespol-kontakt.jpg" alt="Zdjęcie zespołu Gainvest">
      </div>
      <div class="small-12 medium-7 columns">
        <div class="row">
          <div class="small-12 medium-6 columns">
            <h2 class="gold-font no-uppercase">Gainvest<br>Piotr Rozlach</h2>
            <div class="margin-tp-1 black-line"></div>
            <div class="row">
              <div class="small-6 columns">
                <h2>Adres</h2>
                <div v-html="contact[0]"></div>
              </div>
              <div class="small-6 columns">
                <h2>NIP</h2>
                <div v-html="contact[1]"></div>
              </div>
            </div>
            <h2>Telefon</h2>
            <a :href="`tel:${contact[2]}`">{{ contact[2] }}</a>
            <h2>Mail</h2>
            <a :href="`mail:${contact[3]}`">{{ contact[3] }}</a>
          </div>
          <div class="small-12 medium-6 columns flex-end">
            <div>
              <div class="black-line"></div>
              <div class="row">
                <div class="small-12 large-6 columns">
                  <h3 class="gold-font text-uppercase">Pracownia<br>konstrukcyjna</h3>
                  <h2 class="margin-tp-3">Adres</h2>
                  <div v-html="contact[4]"></div>
                </div>
                <div class="small-12 large-6 columns">
                  <h3 class="gold-font text-uppercase">Pracownia<br>architektoniczna</h3>
                  <h2 class="margin-tp-3">Adres</h2>
                  <div v-html="contact[5]"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      contact: []
    }
  },
  beforeCreate: function () {
    this.$http.get(`contact-data/v1/contact`).then(response => {
      for (let post in response.data) {
        this.contact.push(response.data[post])
      }
      console.log(this.contact)
    }, error => { console.log(error) })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue